// material
import { Box, Chip, Container, Stack, Typography } from '@material-ui/core';
import { experimentalStyled as styled } from '@material-ui/core/styles';
// components
import Page from '../../components/Page';
import { LoginForm } from '../../components/authentication/login';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AVAILABLE_MFA_METHODS } from 'src/@types/authentication';
import Logo from 'src/components/Logo';
import LanguagePopover from 'src/components/app-components/LanguagePopover';
import { currentEnv } from 'src/config';
import { UpdatePasswordForm } from '../../components/authentication/update-password';
import { VerifyMfaCodeForm } from '../mfa/components/form';
// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------
/**
 *
 * @return コンポーネント
 */
export const Login = () => {
  const [user, setUser] = useState(null);
  // MFA対応 start --------------
  const [isVerifyMfaCode, setIsVerifyMfaCode] = useState(false); // MFA認証コード入力要否
  const [isNeedNewPassword, setIsNeedNewPassword] = useState(false); // パスワード変更要否
  const [activeMfaMethod, setActiveMfaMethod] = useState<AVAILABLE_MFA_METHODS | null>(null); // 選択済みのMFA方式
  const [isRequiredMfa, setIsRequiredMfa] = useState(false); // MFA認証要否
  const { t } = useTranslation();
  // MFA対応 end ----------------
  const [, setIsLanguageMenuOpen] = useState(false); // 言語選択メニュー開閉(再レンダリングをトリガーし、左側のツールチップの位置を再計算して、揺れを防ぐ)

  // ログインパスワード変更Form
  const updatePasswordForm = () => {
    return (
      <>
        <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h4" gutterBottom>
              {t('updatePassword.title')}
            </Typography>
          </Box>
        </Stack>
        {/* MFA対応 start ---------------- */}
        <UpdatePasswordForm setIsVerifyMfaCode={setIsVerifyMfaCode} setActiveMfaMethod={setActiveMfaMethod} isRequiredMfa={isRequiredMfa} />
        {/* MFA対応 end ---------------- */}
      </>
    );
  };

  // MFA対応 start --------------
  // MFA認証コード入力画面
  const verifyMfaCode = () => {
    return (
      <>
        <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h4" gutterBottom>
              {t('mfa.title.verifyOTP')}
            </Typography>
          </Box>
        </Stack>
        <VerifyMfaCodeForm activeMfaMethod={activeMfaMethod} />
      </>
    );
  };
  // MFA対応 end ----------------

  // ログインForm
  const mainLoginForm = () => {
    return (
      <>
        {/* MFA対応 start ---------------- */}
        <LoginForm
          setIsVerifyMfaCode={setIsVerifyMfaCode}
          setIsNeedNewPassword={setIsNeedNewPassword}
          setActiveMfaMethod={setActiveMfaMethod}
          setIsRequiredMfa={setIsRequiredMfa}
        />
        {/* MFA対応 end ---------------- */}
      </>
    );
  };

  return (
    <RootStyle title="Login | BONSAI">
      <Container maxWidth="sm">
        <ContentStyle>
          {currentEnv !== 'production' ? (
            <>
              <Stack direction="row" alignItems="center" sx={{ mb: 12 }}>
                {' '}
                <Chip
                  style={{
                    flexGrow: 1,
                    width: '50%',
                    fontWeight: 'bold',
                  }}
                  label={'この環境は ' + currentEnv + ' です。'}
                  color="primary"
                  variant="outlined"
                />
              </Stack>
            </>
          ) : (
            <></>
          )}
          {!user ? (
            <>
              <Stack direction="row" alignItems="center" sx={{ mb: 3 }}>
                <Box sx={{ flexGrow: 1 }} alignItems="center">
                  <Stack sx={{ alignItems: 'center' }}>
                    <Logo sx={{ width: '100px', height: '100px' }} />
                    <Typography
                      style={{
                        paddingBottom: '0px',
                        fontSize: '40px',
                        fontWeight: '900',
                        fontStyle: 'normal',
                        fontFamily: 'Nunito',
                      }}>
                      BONSAI
                    </Typography>
                    <Typography sx={{ color: 'text.secondary' }}>Global Data Collector </Typography>
                  </Stack>
                </Box>
              </Stack>
              <Stack alignItems="center">
                <LanguagePopover withTooltip={true} onOpenChange={setIsLanguageMenuOpen} />
              </Stack>

              {/* MFA対応 start ---------------- */}
              {/* フォーム表示 */}
              {isVerifyMfaCode ? verifyMfaCode() : isNeedNewPassword ? updatePasswordForm() : mainLoginForm()}
              {/* MFA対応 end ---------------- */}
            </>
          ) : (
            <>
              <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="h4" gutterBottom>
                    Update your password
                  </Typography>
                </Box>
              </Stack>
              {/* MFA対応 start ---------------- */}
              {/* フォーム表示 */}
              {isVerifyMfaCode ? verifyMfaCode() : isNeedNewPassword ? updatePasswordForm() : mainLoginForm()}
              {/* MFA対応 end ---------------- */}
            </>
          )}
          <Box style={{ height: '200px' }}></Box>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
};
export default Login;
